import React from 'react';
import {Select} from 'antd';
import {connect} from 'react-redux';
import ProductAction from '../../actions/ProductAction.js';
import AjaxAction from '../../actions/AjaxAction.js';

class ProductSelect extends React.Component {
    static defaultProps = {

    };

    state = {
        //list:[]
    };

    //getList() {
    //    var now = Date.now();
    //    if(now > ((ProductSelect.cache.expires||0) + 30*1000)) {
    //        let {dispatch} = this.props;
    //        dispatch(AjaxAction.productList()).then(data=>{
    //            this.setState({
    //                list:data.data
    //            });
    //
    //            ProductSelect.cache = {
    //                expires:Date.now(),
    //                list:data.data
    //            };
    //        });
    //    }else {
    //        this.setState({
    //            list:ProductSelect.cache.list
    //        });
    //    }
    //}

    componentDidMount() {
        //this.getList();
    }

    renderOptions() {
        return this.props.list.map(item=>{
            return <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>;
        });
    }

    render() {
        let value = this.props.value ? this.props.value.split(",") : [];
        return this.props.list && this.props.list.length ? <Select
            mode="multiple" style={{ width: '100%' }}
            placeholder="请选择产品"
            disabled={this.props.disabled}
            onChange={this.props.onChange}
            value={value}>
            {this.renderOptions()}
        </Select> : <span>暂无产品</span>;
    }
}

ProductSelect.cache = {

};

export default connect((state) => ({
    list:state.productList
}))(ProductSelect);



// WEBPACK FOOTER //
// ./src/components/Select/ProductSelect.js